import {FlowEdge, FlowNode} from './types';

export function connect_orphaned_nodes(
  nodes: FlowNode[],
  edges: FlowEdge[],
  edgeParams?: Partial<FlowEdge>,
): {nodes: FlowNode[]; edges: FlowEdge[]} {
  const start_node = nodes.find(n => n.type === 'start');
  if (!start_node) {
    return {nodes, edges};
  }
  // Find nodes that don't have any incoming edges
  const nodesWithoutIncomingEdges = nodes.filter(node => {
    // Skip the start node itself
    if (node.id === start_node.id) {
      return false;
    }

    // Check if this node has any incoming edges
    return !edges.some(edge => edge.target === node.id);
  });

  // Connect start node to all orphaned nodes
  const newEdges = [
    ...edges,
    ...nodesWithoutIncomingEdges.map(node => ({
      id: `xy-edge__${start_node.id}-${node.id}`,
      source: start_node.id,
      target: node.id,
      ...edgeParams,
    })),
  ];

  return {nodes, edges: newEdges};
}
